import { ProductSwitchOfferQuery } from "src/api/productSwitchOffers";
import { convertGqlSwitchOperationToProto } from "src/utils/orderConversions";
import { getMedSKUByProductName } from "src/utils/plans";
import { setSwitchOperation } from "src/utils/redux/slices/checkoutOrders";
import { setProductSwitchData } from "src/utils/redux/slices/productSwitch";
import { setRecommendationContext } from "src/utils/redux/slices/recommendationContext";
import getStore from "src/utils/redux/store";

/**
 * Sets the given product switch offer as the checkout order.
 */
export function setProductSwitchOffer(offer: ProductSwitchOfferQuery) {
  const { dispatch } = getStore();
  const { switchOperation } = offer;
  const medSku = getMedSKUByProductName(offer.productName);

  dispatch(
    setSwitchOperation({
      saleItem: {
        saleItemId: switchOperation.saleItemId,
        trialSaleItemId: switchOperation.trialSaleItemId,
        medSku,
      },
      switchOperation: convertGqlSwitchOperationToProto(switchOperation),
    })
  );

  if (medSku) {
    dispatch(setRecommendationContext({ selectedMedPlan: medSku }));
  }

  dispatch(
    setProductSwitchData({
      isDeferredSwitch:
        // eslint-disable-next-line no-underscore-dangle
        switchOperation.switchType?.__typename === "NextBillingCycleSwitch",
    })
  );
}
